

import * as React from "react";
import * as Layout$RecountTools from "../../layout/Layout.bs.js";
import * as PageHistory$RecountTools from "../../util/PageHistory.bs.js";

function Page_Error(Props) {
  PageHistory$RecountTools.revertPage(undefined);
  return React.createElement(Layout$RecountTools.AppContainer.make, {
              children: React.createElement(Layout$RecountTools.Columns.make, {
                    children: React.createElement(Layout$RecountTools.Columns.Column.make, {
                          children: "Something went wrong. Please contact your dev team for assistance."
                        })
                  }),
              pageName: "Error"
            });
}

var make = Page_Error;

export {
  make ,
  
}
/* react Not a pure module */
